import React , {useState, useEffect} from 'react';
import { MenuForm } from '../Menu.js';
import { SecurityElement } from '../elements/security_element.js';  
import "../../css/main.css"
import { YearsElement } from '../elements/years_element.js';
import { VisitListElement } from '../elements/visit_list_element.js';
import { useAPICall } from '../../hooks/useAPICall.js';
import { PageMenuElement } from '../elements/page_menu.js'

export function VisitsForm() {

    const [yearName, setYearName] = useState('');
   const [pageData, setPageData] = useState();
  
  const [visitData, setVisitData] = useState([]);
  const [yearsData, setYearsData] = useState([]);

  const handleDataFetch = (data) =>
  {
      setPageData(data);
      if(yearName.length === 0)
      {
        setYearName(data.components['years'][0]);
      }
      
      setVisitData(data.components['visits']);
      setYearsData(data.components['years']);
     
  
  }
  const {MakeCall} = useAPICall();
  


  function handleYearClicked(yearName)
  {
    setYearName(yearName);
    MakeCall('member/getmembervisitpage', "{ \"token\" : \"" + sessionStorage.getItem("Token") + "\", \"yearname\" : \"" + yearName + "\"}", handleDataFetch, true);   
  }
  
  function onPageMenuClick(onclickname) {
  }

  useEffect(()=>
  {              
      MakeCall('Member/getmembervisitpage', "{ \"token\" : \"" + sessionStorage.getItem("Token") + "\", \"yearname\" : \"" + yearName + "\"}", handleDataFetch);
  });

    return (
        <div>
            
            {SecurityElement(pageData)}
            {MenuForm()}    
            <div className="contentdiv">
            {PageMenuElement("Visits", [], onPageMenuClick, false)}              
            {<p>Visits are not available</p>}
            {/* <p>Your visits for the last 3 years can be seen below. Click a year to see the visits for that year. These are collected automatically from the POS system.</p> */}
            {/* {YearsElement(yearsData, handleYearClicked)}
            {VisitListElement(visitData, yearName)} */}
            </div>            
            
        </div>
    

    );
}
